import React from 'react';
import Heading from 'components/Heading';
import Row, { RowSize } from 'components/Row';
import Text, { TextSize } from 'components/Text';

type Props = {
  children: React.ReactNode;
  // size only impacts the spacing below the heading
  size?: RowSize;
  textSize?: TextSize;
  centerText?: true;
  level?: '1' | '2';
};

export default function CoachingHeading(props: Props) {
  return (
    <Row size={props.size ?? 'small'}>
      <Heading level={props.level ?? '1'} serif flush>
        <Text
          color="ink"
          weight="semibold"
          size={props.textSize}
          align={props.centerText && 'center'}>
          {props.children}
        </Text>
      </Heading>
    </Row>
  );
}
